import { CommandBase } from "../../../common/services/cqs/commandManager";

export class SetJusteradRedovisningshanvisningCommand extends CommandBase {
    inmatningshandelssortiment: string;
    arbetsorderId: number;
    redovisningshanvisning: string;
    mottagningsplatsnummer: string;
    typ: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetJusteradRedovisningshanvisningCommand";
    constructor(init: (instance: SetJusteradRedovisningshanvisningCommand) => void) {
        super(SetJusteradRedovisningshanvisningCommand.$type);
        init(this);
    }
}
